import { render, staticRenderFns } from "./customTable.vue?vue&type=template&id=3fdb67ac&"
import script from "./customTable.vue.ts?vue&type=script&lang=ts&"
export * from "./customTable.vue.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports